import { UKFlagIcon, FranceFlagIcon, LogoutIcon } from "assets/icons";
import { useLanguage } from "hooks";
import { useClearSession } from "modules/auth";
import { useTranslation } from "react-i18next";
import { Icon } from "ui";

import styles from "./LogoutModal.module.scss";

const LogoutModal = () => {
  const logout = useClearSession();
  const { switchLanguage, isEnglishActive } = useLanguage();
  const { t } = useTranslation();

  return (
    <div className={styles.modal}>
      <div className={styles.modal__wrapper}>
        <div
          className={styles.modal__wrapper__item}
          onClick={async (e) => {
            e.stopPropagation();
            await switchLanguage();
          }}
        >
          <Icon
            className={styles.modal__wrapper__item__icon}
            as={isEnglishActive ? UKFlagIcon : FranceFlagIcon}
            boxSize={20}
            color="#090914"
          />
          <p>{t("Language")}</p>
        </div>
        <div className={styles.modal__wrapper__item} onClick={logout}>
          <Icon
            className={styles.modal__wrapper__item__icon}
            as={LogoutIcon}
            boxSize={20}
            color="#090914"
          />
          <p>{t("Logout")}</p>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
